// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-components-forms-radioButton-module__inlineOption--FpJcD {
  display: inline;
}

.src-js-components-forms-radioButton-module__option--nq3ik {
  display: block;
  width: 100%;
}

.src-js-components-forms-radioButton-module__label--Nx5Lr {
  cursor: pointer;
  width: auto;
  margin-top: 5px !important;
  font-weight: 500;
}

.src-js-components-forms-radioButton-module__radioButtonInput--mjZhw {
  cursor: pointer;
  width: 20px;
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/forms/radioButton.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd","sourcesContent":[".inlineOption {\n  display: inline;\n}\n\n.option {\n  display: block;\n  width: 100%;\n}\n\n.label {\n  cursor: pointer;\n  width: auto;\n  margin-top: 5px !important;\n  font-weight: 500;\n}\n\n.radioButtonInput {\n  cursor: pointer;\n  width: 20px;\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inlineOption": `src-js-components-forms-radioButton-module__inlineOption--FpJcD`,
	"option": `src-js-components-forms-radioButton-module__option--nq3ik`,
	"label": `src-js-components-forms-radioButton-module__label--Nx5Lr`,
	"radioButtonInput": `src-js-components-forms-radioButton-module__radioButtonInput--mjZhw`
};
export default ___CSS_LOADER_EXPORT___;
